export default __webpack_public_path__ + "static/10.02-d29f2d41c2a79da7ed62668112d833d5.png";